import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-logout',
  imports: [],
  templateUrl: './icon-logout.component.html',
})
export class IconLogoutComponent {
  @Input() color: string = '#fff';
  @Input() size: string = '24px';
}
